import { useEffect, useState } from 'react'
import { MarginOverviewRow, MarginValuationOverview, SiteMarginConfig } from '../../../types/MarginValuation'
import { useSites } from '../../../hooks/useSites'
import BackOfficeAPIClient from '../../../clients/BackofficeAPIClient'
import { buildBrandConfigs, groupByDealershipId, toSummary } from '../utils/marginValuationUtils'
import { buildSaveTargetQuery, SaveTarget } from '../moduleVoNavigation'

const backofficeApiClient = new BackOfficeAPIClient()

// Charge toutes les lignes en une fois et les répartit en 3 groupes pour la page d'aperçu :
// global, par site, par marque (cf. buildBrandConfigs pour le regroupement).
export function useMarginValuationOverview(): MarginValuationOverview {
    const sites = useSites()
    const [ data, setData ] = useState<MarginOverviewRow[]>([])

    const fetchData = () => {
        backofficeApiClient.get<MarginOverviewRow[]>('/valuation-settings/overview')
            .then(setData)
            .catch(console.log)
    }

    useEffect(() => {
        fetchData()
    }, [])

    const deleteConfig = async (target: SaveTarget) => {
        const query = buildSaveTargetQuery(target)
        await backofficeApiClient.delete(`/valuation-settings${query}`, undefined)
        fetchData()
    }

    const siteNameById = new Map(sites.map(site => [ site.value, site.label ]))

    const globalRow = data.find(row => row.dealership_id === null && row.brand === null)
    const globalConfig = toSummary(globalRow)
    const siteRowById = groupByDealershipId(data.filter(row => row.brand === null))
    const brandScopedData = data.filter(row => row.brand !== null)

    const siteConfigs: SiteMarginConfig[] = Array.from(siteRowById.entries()).map(([ dealershipId, siteRow ]) => ({
        dealershipId,
        siteName: siteNameById.get(dealershipId) ?? `Site ${dealershipId}`,
        ...toSummary(siteRow),
    }))

    return {
        sites: sites.map(site => ({ id: site.value, name: site.label })),
        brandConfigs: buildBrandConfigs(brandScopedData, siteNameById),
        siteConfigs,
        globalConfig,
        deleteConfig,
    }
}
